import { Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import { updateUser } from "../../api/users";

export default function IsicomGetStarted(props) {

    function doNotDisplay() {
        localStorage.setItem("showisicomgetstarted", false);
    }

    function onSubmit() {
        updateUser(props.user.id, {
            metadata: { ...props.user.metadata, isicom_agent_id: this.state.agent_id }
        }).then((response) => {
            props.onHide();
        });
    }

    return (
        <>
            <Modal show={props.show ?? false} onHide={() => props.onHide()}>
                <Modal.Header closeButton>
                    <Modal.Title>Configuration isicom</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form id="form-isicom-getstarted" onSubmit={onSubmit}>
                        <FloatingLabel label="Numéro d'agent">
                            <Form.Control type="text" placeholder="1001" />
                        </FloatingLabel>
                        <div className={`mt-4`}>
                            <Form.Check onChange={() => doNotDisplay() } type="switch" label="Ne plus afficher" id="disabled-custom-switch" />
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button form="form-isicom-getstarted" type="submit">Enregistrer</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
